import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service'
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  fragment: any;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("sdfsf")
    const currentuserDeatils = JSON.parse(localStorage.getItem('currentUserDetails'));
    const currentUser = this.authenticationService.currentUserValue;
    var child = route.firstChild;
    this.fragment = route.firstChild.fragment

    console.log(child)
    console.log(this.fragment)
    console.log("16 currentUser :", currentUser)
    if (currentUser) {
      if (child.data.state == 'cnss-approval-form' || child.data.state == 'link-business' || child.data.state == 'cnamgs-form' || child.data.state == 'dashboard' || child.data.state == 'employees' || child.data.state == 'employee-history' || child.data.state == 'cnss-reports' || child.data.state == 'cnamgs-report' || child.data.state == 'cnss-reportList' || child.data.state == 'cnamgs-reportlist' || child.data.state == 'cnss-report-view' || child.data.state == 'cnamgs-reportview' || child.data.state == 'salary-revise' || child.data.state == 'dependence' || child.data.state == 'dependence-list' || child.data.state == 'experience' || child.data.state == 'cnss' || child.data.state == 'get-started') {
        const canActivate = this.getActive(child.data.state);
        console.log("21", canActivate)
        if (!canActivate) {
          this.router.navigate(['/dashboard']);
        } else {
          return true;
        }
      } else {
        return true;
      }
      // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      this.router.navigate(['/']);
      return false;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

  getActive(val) {
    const currentuserDeatils = JSON.parse(localStorage.getItem('currentUserDetails'));
    console.log("37 currentuserDeatils", currentuserDeatils)
    switch (val) {

      case 'cnss-approval-form':
      case 'cnamgs-form':
        if (!currentuserDeatils || currentuserDeatils.BankDetails === 0) {
          return false;
        } else {
          if (val == 'cnss-approval-form') {
            if (currentuserDeatils.cnss === 0 || currentuserDeatils.cnss === 3) {
              return true;
            } else {
              return false;
            }
          } else {
            if (currentuserDeatils.cnamgs === 0 || currentuserDeatils.cnamgs === 3) {
              return true;
            } else {
              return false;
            }
          }
        }

      case 'link-business':
      case 'get-started':
        if (!currentuserDeatils || currentuserDeatils.GNI === 1) {
          console.log("64")
          if (this.fragment == "cnamgsresubmit" || this.fragment == "cnssresubmit" || this.fragment == "managecompany") {
            return true;
          } else {
            return false;
          }

        } else {
          return true;
        }
      case 'dashboard':
        if (currentuserDeatils.current_user == 1 && currentuserDeatils.GNI === 0) {
          console.log("71")
          return false;
        } else {
          return true;
        }
      case 'employees':
        if (currentuserDeatils.current_user == 2 || currentuserDeatils.current_user == 1 && currentuserDeatils.GNI === 0) {
          return false;
        } else {
          return true;
        }
      case 'employee-history':
        if (currentuserDeatils.current_user == 1 && currentuserDeatils.GNI == 0 && currentuserDeatils.EmployeeDetails ==0) {
          return false;
        } else {
          return true;
        }
      case 'cnss-reports':
      case 'cnamgs-report':
        if (currentuserDeatils.current_user == 2 || currentuserDeatils.current_user == 1 && currentuserDeatils.GNI === 0) {
          return false;
        } else {
          return true;
        }
      case 'cnss-reportList':
      case 'cnamgs-reportlist':
        if (currentuserDeatils.current_user == 2 || currentuserDeatils.current_user == 1 && currentuserDeatils.GNI === 0) {
          return false;
        } else {
          return true;
        }
      case 'cnss-report-view':
      case 'cnamgs-reportview':
        if (currentuserDeatils.current_user == 2 || currentuserDeatils.current_user == 1 && currentuserDeatils.GNI === 0) {
          return false;
        } else {
          return true;
        }
      case 'salary-revise':
        if ((currentuserDeatils.current_user == 1 && currentuserDeatils.GNI === 0)) {
          return false;
        } else {
          return true;
        }
      case 'dependence':
      case 'experience':
        if (currentuserDeatils.EmployeeDetails == 0) {
          console.log("108")
          return false;
        } else {
          console.log("111")
          return true;
        }
      default:
        return true;
    }
  }
}
